export const SHOW_CANCEL_ANYTIME_MESSAGING_FOR_PP = 'show_cancel_anytime_messaging_for_pp';
export const UPDATE_PERSONAL_PLAN_TOPIC_PAGE = 'update_personal_plan_topic_page';
export const PERSONAL_PLAN_COURSE_ENROLLMENT = 'personal_plan_course_enrollment';
export const UPDATE_UDEMY_BUSINESS_TOPIC_PAGE = 'update_udemy_business_topic_page';
export const MARKETPLACE_SUBSCRIPTION_OFFER = 'marketplace_subscription_offer';
export const ADD_SUBHEADINGS_TO_CAT_SUBCAT_TOPIC_RECOMMENDATIONS =
    'add_subheadings_to_cat_subcat_topic_recommendations';
export const DELAY_COURSE_CARD_QUICK_VIEW_BOX = 'delay_course_card_quick_view_box';
export const HIDE_WISHLIST_BUTTON_ON_COURSE_CARD_QUICK_VIEW_BOX =
    'hide_wishlist_button_on_course_card_quick_view_box';
export const COURSE_CARDS_OPEN_IN_NEW_TAB = 'course_cards_open_in_new_tab';
export const ENABLE_CONTEXTUAL_HEADER_ON_TOPICS_PAGE = 'enable_contextual_header_on_topics_page';
export const AUTH_FULL_PAGE_REDIRECT = 'auth_full_page_redirect';
export const QUICK_VIEW_BOX_FEATURE = 'quick_view_box_feature';
export const INDEED_LINKS_ON_AGGREGATOR_PAGES = 'indeed_links_on_aggregator_pages';
export const SHOW_VALUE_STARTER_PLAN = 'value_planstarter_plan';
